import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {SetAttributeLocalizationCommand} from "./setAttributeLocalization.command";
import {mintNamespacedUid} from "../utils/uid.utils";

export class AddConstantUnitAttribute extends CommandBase {
    id: string;

    constructor(id: string) {
        super();
        this.id = id;
    }

    execute(state: RemoteConstantsModel): boolean {
        if (this.id === '') {
            return false;
        }

        if (state.unitAttributes === undefined) {
            state.unitAttributes = [];
        }

        const uid = mintNamespacedUid('unitattribute', this.id, state.unitAttributes.map(a => a.uid));
        new SetAttributeLocalizationCommand(uid, this.id).execute(state);

        state.unitAttributes.push({
            uid: uid,
            id: this.id,
            active: true,
            values: {},
            entities: {}
        });
        return true;
    }
}